<template>
  <footer>
    <div class="navbar container">
      <div class="left">
        <b-button v-if="hasPrev" :disabled="disabledPrev"
                  variant="link" class="prev-btn" @click="$emit('prev')">
          <img src="../assets/icons/left-arrow.svg">
          <span>Indietro</span>
        </b-button>
      </div>
      <div class="right">
        <b-button v-if="hasNext" :disabled="disabledNext" variant="primary" pill class="next-btn" @click="$emit('next')">
          <span>Avanti</span>
        </b-button>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterNavComponent",
  props: {
    hasPrev: {
      type: Boolean,
      default: true,
    },
    hasNext: {
      type: Boolean,
      default: true,
    },
    disabledPrev: {
      type: Boolean,
      default: false,
    },
    disabledNext: {
      type: Boolean,
      default: false,
    },
  },
  methods: {}
}
</script>

<style scoped lang="scss">
footer {
  padding: 4px 16px;
  border-top: 1px solid #0000001A;
  background: #ECF1F4;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 80px;
  display: flex;
  align-items: center;

  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;

    button{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      text-transform: uppercase;
      line-height: 1;
      &.next-btn{
        font-size: 16px;
        font-weight: 700;
        padding: 15px 50px;
        background: #00205b;
      }
      &.prev-btn{
        font-size: 12px;
        font-weight: 600;
        color: #516574;
      }
      &:disabled{
        opacity: 0.2;
      }
    }
  }
}
</style>